import React from 'react';
import { ScorecardTemplate } from '../../../entities/v1/applicant_tracking/ScorecardTemplate';
import { findSectionType } from '../../../utils/applicant_tracking/scorecardSurvey';
import { OpenTextSection } from './OpenTextSection';
import { Section } from '../../../entities/v1/survey_engine/Section';
import { RatingSection } from './RatingSection';
import { HorizontalDivider } from '../../HorizontallDivider';

interface PropTypes {
  scorecardTemplate: ScorecardTemplate;
  showFieldLabels?: boolean;
  preview?: boolean;
}

function ScorecardQuestion(props: PropTypes & { section: Section }) {
  switch (findSectionType(props.section)) {
    case 'rating':
      return (
        <RatingSection
          section={props.section}
          showFieldLabels={props.showFieldLabels}
          preview={props.preview}
        />
      );
    case 'text':
      return (
        <OpenTextSection
          section={props.section}
          preview={props.preview}
          showFieldLabels={props.showFieldLabels}
        />
      );
    default:
      return null;
  }
}

export function ScorecardTemplateTable(props: PropTypes) {
  return (
    <>
      {props.scorecardTemplate.surveyTemplate.sections?.map(
        (section: Section, index: number) => {
          return (
            <div key={index}>
              <ScorecardQuestion {...props} section={section} />
              {index !==
              props.scorecardTemplate.surveyTemplate.sections.length - 1 ? (
                <HorizontalDivider classNames='my-5h' />
              ) : null}
            </div>
          );
        },
      )}
    </>
  );
}
